import { render, staticRenderFns } from "./Summary.vue?vue&type=template&id=01a1aa61&"
import script from "./Summary.vue?vue&type=script&lang=js&"
export * from "./Summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/lifecheq/htdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01a1aa61')) {
      api.createRecord('01a1aa61', component.options)
    } else {
      api.reload('01a1aa61', component.options)
    }
    module.hot.accept("./Summary.vue?vue&type=template&id=01a1aa61&", function () {
      api.rerender('01a1aa61', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Calculators/MyCover/Summaries/Tabs/Summary.vue"
export default component.exports